export default "__VITE_ASSET__CEZb9m0X__"